module.exports = __webpack_public_path__ + "img/nemotron-loss-graph.9e0f86db.png";